// TODO write documentation
// TODO cover by unit tests
angular.module('gateApp').component('swVideo', {
  template: require('./sw-video.html').default,
  bindings: {
    videos: '<',
  },
  controller: function ($element, $timeout: ng.ITimeoutService, matchMedia) {
    const $ctrl = this;
    let video;

    $ctrl.$onInit = () => {
      video = $element.find('video');

      if (matchMedia.isPhone()) {
        video[0].setAttribute('preload', 'none');
      } else {
        video[0].setAttribute('autoplay', 1);
      }

      if (!angular.isArray($ctrl.videos)) {
        return;
      }

      $ctrl.videos = $ctrl.videos.map((video) => {
        return {
          file: video.file,
          type: video.type,
          image: video.image,
        };
      });

      $ctrl.video =
        $ctrl.videos[Math.floor(Math.random() * $ctrl.videos.length)];

      $element.children().css({
        'background-image': `url(${$ctrl.video.image})`,
      });
    };

    function canplaythrough() {
      video.css({
        display: 'block',
      });
    }

    $ctrl.$postLink = () => {
      $timeout(() => {
        video.on('canplaythrough', canplaythrough);
      });
    };

    $ctrl.$onDestroy = () => {
      video.off('canplaythrough', canplaythrough);
    };
  },
});
